module.exports = __webpack_public_path__ + "static/img/y61.34022ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/view/images/y61.png
// module id = 7Hcv
// module chunks = 1